<template>
  <div id="WellnessSafety">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"></usc-intro>
    <div class="body mb gutter-lg">
      <h2>Wellness and Safety</h2>

      <address>
        <strong>USC Counseling and Mental Health</strong><br />
        <a href="https://sites.usc.edu/counselingandmentalhealth/" class="inline-hyperlink" target="_blank">https://sites.usc.edu/counselingandmentalhealth/</a><br />
        Crisis support 24/7
      </address>

      <address>
        <strong>Department of Public Safety</strong><br />
        Parking Structure A<br />
        <a href="https://dps.usc.edu" class="inline-hyperlink" target="_blank">https://dps.usc.edu</a><br />
        (213) 740-4321 (emergencies)<br />
        (213) 740-6000 (general)
      </address>

      <address>
        <strong>Engemann Student Health Center</strong><br />
        1031 W. 34th Street <br />
        <a href="https://studenthealth.usc.edu" class="inline-hyperlink" target="_blank">https://studenthealth.usc.edu</a><br />
        (213) 740-9355
      </address>

      <address>
        <strong>USC Health Center Pharmacy</strong><br />
        <a href="https://pharmacies.usc.edu/pharmacies/usc-health-center-pharmacy/" class="inline-hyperlink" target="_blank">https://pharmacies.usc.edu/pharmacies/usc-health-center-pharmacy/</a><br />
        1150 West Jefferson Blvd., Suite 150<br />
        (213) 821-6100
      </address>


      <address>
        <strong>USC Health Center Pharmacy vending machine</strong><br />
        King Hall lobby (wellness-to-go 24/7)
      </address>

      <address>
        <strong>USC Dental Plan Option</strong><br />
        <a href="https://www1.deltadentalins.com/group-sites/usc.html" class="inline-hyperlink" target="_blank">https://www1.deltadentalins.com/group-sites/usc.html</a><br />
      </address>

      <address>
        <strong>USC Student Health</strong><br />
        <a href="https://studenthealth.usc.edu" class="inline-hyperlink" target="_blank">https://studenthealth.usc.edu</a><br />
        (213) 740-WELL (9355)
      </address>
    </div>

  </div>
</template>

<script>

import hero from '@/components/Hero'
import intro from '@/components/Intro'
import cta from '@/components/Cta'
import videoEmbed from '@/components/videoEmbed'
import linkGroup from '@/components/LinkGroup'

export default {
  name: 'WellnessSafety',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': cta,
    'usc-videoEmbed': videoEmbed,
    'usc-linkGroup': linkGroup
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Wellness and Safety',
        loResSrc: '../../../static/Wellness-Safety_Hdr.jpeg',
        hiResSrc: '../../../static/Wellness-Safety_Hdr.jpeg'
      },
      intro: [
        'There are many resources available to you at USC and within USC Marshall. This section lists and details some key primary sources to consult when you need support.'
      ],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [
            {
              text: 'USC',
              url: 'https://www.usc.edu/'
            },
            {
              text: 'USC Marshall',
              url: 'https://www.marshall.usc.edu/'
            }
          ]
        },
        1: {
          title: 'Helpful Web Links',
          links: [
            {
              text: 'Academic Calendar',
              url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
            },
            {
              text: 'Athletics',
              url: 'http://usctrojans.com/'
            },
            {
              text: 'Bookstore',
              url: 'https://www.uscbookstore.com/'
            },
            {
              text: 'Catalogue',
              url: 'http://catalogue.usc.edu/'
            },
            {
              text: 'Class Schedule',
              url: 'http://classes.usc.edu/'
            },
            {
              text: 'Center for Black Cultural and Student Affairs',
              url: 'https://cbcsa.usc.edu/'
            },
            {
              text: 'El Centro Chicano',
              url: 'http://sait.usc.edu/elcentro/'
            },
            {
              text: 'Financial Aid',
              url: 'https://financialaid.usc.edu/'
            },
            {
              text: 'Housing',
              url: 'http://housing.usc.edu/'
            },
            {
              text: 'Marshall Mashup (Current Student Blogs)',
              url: 'http://marshallmashup.usc.edu'
            },
            {
              text: 'OASIS',
              url: 'https://usc.edu/OASIS'
            },
            {
              text: 'Orientation',
              url: 'https://orientation.usc.edu/'
            },
            {
              text: 'Recreational Sports',
              url: 'https://sait.usc.edu/recsports/'
            },
            {
              text: 'Student Health Center',
              url: 'http://engemannshc.usc.edu/'
            },
            {
              text: 'Student Organizations',
              url: 'http://campusactivities.usc.edu/'
            },
            {
              text: 'Transportation Services',
              url: 'http://transnet.usc.edu/'
            },
            {
              text: 'Undergraduate Admissions',
              url: 'http://admit.usc.edu/'
            },
            {
              text: 'Volunteer Center',
              url: 'http://campusactivities.usc.edu/'
            }
          ]
        }
      }
    }
  },
  created () {
    this.$root.setPageHeader('Resources', 'WellnessSafety')
  }
}
</script>
<style scoped lang="scss">
  @import '~styles/vars';
  #c5-wrapper {
    h4 {
      margin-bottom: 10px;
    }
    address {
      margin-bottom: 25px;
      font-style: normal;
    }
    .resources-link {
      color: $cBody;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/resources/WellnessSafety.vue